import { Compass } from "lucide-react";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";

import { PageState } from "../components/states";
import { ButtonLink } from "../components/ui";
import { LANDING_URL } from "../lib/runtime-config";

/** Cualquier ruta que no existe. Siempre con marca y con una salida. */
export default function NotFound(): ReactNode {
  return (
    <PageState
      icon={<Compass className="size-7" />}
      title="Esta página no existe"
      message="El enlace que seguiste no existe o cambió de dirección."
      actions={
        <>
          <Link
            to="/"
            className="inline-flex h-11 items-center justify-center gap-2 rounded-lg bg-brand-600 px-5 font-medium text-white shadow-sm transition hover:bg-brand-700"
          >
            Ir al inicio
          </Link>
          <ButtonLink href={LANDING_URL} size="lg">
            Conocer TurnPro
          </ButtonLink>
        </>
      }
    />
  );
}
